import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import CashierPreviewRoot from "./cashier-preview/CashierPreviewRoot";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Caching service worker registration/unregistration is handled separately


const root = createRoot(document.getElementById("root"));

// The /cashier-preview route mounts the builder-driven preview shell instead of
// the full app (no router/auth/geo/security — CashierRedesign needs none of them).
const isPreview = window.location.pathname.replace(/\/+$/, "") === "/cashier-preview";

root.render(
  <React.StrictMode>
    {isPreview ? <CashierPreviewRoot /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
